import { HandlersCollection, RefSerializer } from "@tblabs/truffle";
import { MessageBus } from "../../Services/MessageBus/MessageBus";
import { ChatEntry } from "../Models/ChatEntry";
import { IChatConnector } from "../Services/IChatConnector";
import { RawChatEntry } from "../Models/RawChatEntry";
import { AddEntryCommand } from "./Messages/AddEntryCommand";
import { ReadChatQuery } from "./Messages/ReadChatQuery";


export class RemoteStorageChatConnector implements IChatConnector
{
	private onMessage = new HandlersCollection();

	constructor(private _bus: MessageBus, private chatId: string) { }

	public async AddOrUpdate(entry: ChatEntry): Promise<void>
	{
		await this._bus.SendMessage(new AddEntryCommand(this.chatId, entry.AsRaw, "Chats"));
	}

	public OnMessage(handler: (message: ChatEntry) => void): void
	{
		this.onMessage.Add(handler);
	}

	public async Load(from?: Date, to?: Date): Promise<void>
	{
		const result = await this._bus.SendMessage(new ReadChatQuery(this.chatId, "Chats"));

		if (!result.IsSuccess)
		{
			return;
		}

		const chat: RawChatEntry[] = result.Result;

		for (const message of chat)
		{
			this.onMessage.Call(new ChatEntry(message));
		}
	}
}
